<div>
    <ngb-carousel  [interval]="0" *ngIf="pictures.length > 0; else noImage">
        <ng-template  *ngFor="let img of pictures" [id]="img.slideId" ngbSlide>
            <img class="rounded" [src]="img.url" style="height: 700px; width: 100%; object-fit: cover;" (error)="imgOnError($event)"/>
            <div class="image-caption">
                <div>
                    {{img.type + ' (' + img.orderNum + ')'}} 
                    <ng-container *ngIf="img.name !== 'N/A'">
                        <span> - {{img.name + (img.description ? (' - ' + img.description) : '')}}</span>
                    </ng-container>
                </div>                
                <div class="image-action">
                    <ng-container *ngTemplateOutlet="actionTemplate ? actionTemplate : defaultAction;context:{image: img}"></ng-container>
                </div>
            </div>
        </ng-template>
    </ngb-carousel> 
</div>
<ng-template #noImage>
    <div>No Image is provided</div>
</ng-template>
<ng-template #defaultAction>
</ng-template>